import { useTranslation } from 'react-i18next';

import { CaretIcon } from 'src/components/Icons/icons';

type CalendarNavigationProps = {
    onToday: () => void;
    onPrevious: () => void;
    onNext: () => void;
};

export const CalendarNavigation = ({
    onToday,
    onPrevious,
    onNext,
}: CalendarNavigationProps) => {
    const { t } = useTranslation();

    return (
        <span className="mundu-calendar-navigation">
            <button type="button" onClick={onToday}>
                {t('modules.calendar.views.today')}
            </button>
            <span className="rbc-btn-group">
                <button
                    type="button"
                    className="mundu-calendar-arrow"
                    aria-label={t('modules.calendar.views.previous')}
                    title={t('modules.calendar.views.previous')}
                    onClick={onPrevious}
                >
                    <span
                        className="relative block h-4 w-4 flex-shrink-0 rotate-90"
                        aria-hidden="true"
                    >
                        <CaretIcon />
                    </span>
                </button>
                <button
                    type="button"
                    className="mundu-calendar-arrow"
                    aria-label={t('modules.calendar.views.next')}
                    title={t('modules.calendar.views.next')}
                    onClick={onNext}
                >
                    <span
                        className="relative block h-4 w-4 flex-shrink-0 -rotate-90"
                        aria-hidden="true"
                    >
                        <CaretIcon />
                    </span>
                </button>
            </span>
        </span>
    );
};
